export default __webpack_public_path__ + "static/media/pinecone-crown.b59346e0.png";